export const coreBackendHost = process.env.VUE_APP_BASE_URL || ""
